/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import {
  dispatchdisputedClaimsDetail,
  dispatchSaveCancelClaimsDetail,
} from '../../store/actions';

export default (props) => {
  const dispatch = useDispatch();
  // use Selector function
  const disputedCliamsDetailData = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer
        ?.setDisputedClaimsDetail?.claimData
  );

  const { value } = props;
  // handing onClick event & check validation on filed level
  const handleOnClickEvent = (e) => {
    const newObj = disputedCliamsDetailData;
    newObj[props.rowIndex][props?.column.colId] = e.target?.checked ? 1 : 0;
    dispatch(
      dispatchdisputedClaimsDetail({
        response: disputedCliamsDetailData,
        claimData: newObj,
      })
    );
    dispatch(dispatchSaveCancelClaimsDetail(false));
  };
  return (
    <>
      <div className="tbl-checkbox frr-display-hidden-checkbox-label">
        <FormControlLabel
          label=""
          control={<Checkbox color="primary" />}
          checked={parseInt(value, [0, 1]) === 1}
          value={parseInt(value, [0, 1]) === 1}
          onClick={(e) => {
            handleOnClickEvent(e);
            const checkedVal = e.target.checked ? 1 : 0;
            props.node.setDataValue(props.column.colId, checkedVal);
          }}
        />
      </div>
    </>
  );
};
